export default __webpack_public_path__ + "static/img/background_light.5e2b7b1a.svg";